export default "__VITE_ASSET__BtyOUvGm__"